<div class="text-lg font-semibold border-bottom-2 border-cyan-500 mb-2">Firmeninformation / Rechnungsadresse</div>
{{ businessData.companyName }} <br />
{{ businessData.invoiceStreetAddress }}<br />
{{ businessData.invoicePostalCode }} {{ businessData.invoiceCity }}<br />
{{ businessData.contactEmail }}<br />
Steuernummer: {{ businessData.invoiceAgreementNumber }}<br />
Umsatzsteuer-ID: {{ businessData.invoiceReference }}<br />
